// eslint-disable-next-line
'use strict'
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Grid,
  Typography,
  Button,
  Dialog,
  FormControl,
  FormGroup,
  Snackbar,
} from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Divider from '@material-ui/core/Divider'
import MuiAlert from '@material-ui/lab/Alert'
import DialogContentText from '@material-ui/core/DialogContentText'
import { logEvent, LogLevel } from '@praxis/component-logging'
// import Email from 'react-email-autocomplete'
import '../css/header.css'
// import PhoneCode from 'react-phone-code';
// import PhoneInput from 'react-phone-number-input'
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: 300,
    // margin: theme.spacing.unit,
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
  },
  createForm: {
    padding: 30,
    minWidth: 1000,
    margin: '1% 10% 3% 2%',
    marginLeft: '30px',
    fontFamily: 'Helvetica',
    fontSize: 23,
  },
  formHeaderText: {
    color: 'grey',
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    fontSize: 20,
    fontWeight: 600,
  },
  formHeaderLine: {
    backgroundColor: 'grey',
    height: 3,
    marginTop: theme.spacing.unit,
  },
  countryList: {
    // ...theme.typography.body1,
  },
}))

const GuestDetails = (props) => {
  const location = useLocation()
  const initialMinute = 2,
    initialSeconds = 0
  const emailinitialMinute = 10,
    emailinitialSeconds = 0
  const [emailminutes, setEmailminutes] = useState(emailinitialMinute)
  const [emailseconds, setEmailSeconds] = useState(emailinitialSeconds)
  const [seconds, setSeconds] = useState(initialSeconds)
  const [minutes, setMinutes] = useState(initialMinute)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [reqId, setReqId] = useState(null)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [retrynum, setRetrynum] = useState(0)
  const [block, setBlock] = useState(null)
  const [open, setOpen] = React.useState(false)
  const [dialogblock, setDialogblock] = React.useState(false)
  const [dialogopen, setDialogopen] = useState(false)
  const [dialogemail, setDialogemail] = useState(false)
  const [dis, setDis] = React.useState(true)
  const [disCheck, setDisCheck] = React.useState(true)
  const [disPhone, setDisPhone] = React.useState(true)
  const [disEmail, setDisEmail] = React.useState(true)
  const [disCode, setDisCode] = React.useState(false)
  const [check, setCheck] = React.useState(null)
  const [otp, setOtp] = useState(null)
  const [retry, setRetry] = React.useState(false)
  const [wrongNumber, setWrongNumber] = React.useState(false)
  const [cancel, setCancel] = React.useState(false)
  const [cancelopen, setCancelopen] = React.useState(false)
  // const [mac, setMac] = useState(null)
  // const [baseGrantUrl, setBaseGrantUrl] = useState(null)
  // const [userContinueUrl, setUserContinueUrl] = useState(null)
  // const [successUrl, setSuccessUrl] = useState(null)
  const mac = location.state.mac
  const successUrl = location.state.successUrl
  const loc = location.state.loc
  const devicetype = location.state.deviceType
  const [dialogopenterms, setDialogopenterms] = useState(false)
  const [disTerms, setDisTerms] = React.useState(true)
  // const [accesible, setAccesible] = React.useState(true)
  const [sponsorstatus, setSponsorstatus] = React.useState(null)
  const [checkstatus, setCheckstatus] = React.useState(null)
  // eslint-disable-next-line
  const [disok, setDisok] = React.useState(true)
  const [disresend, setDisResend] = React.useState(true)
  const [resendretry, setResendRetry] = React.useState(true)
  // const [validemail, setValidEmail] = React.useState(null)
  // const [errorMessage, setErrorMessage] = React.useState(null)
  const env = props.env
  //timer counter
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (emailseconds > 0) {
        setEmailSeconds(emailseconds - 1)
        if (reqId !== null && checkstatus !== null) {
          console.log(checkstatus)
          SponsorStatus(reqId)
        }
      }
      if (emailseconds === 0) {
        if (emailminutes === 0) {
          setDisok(false)
          Timeout()
          clearInterval(myInterval)
        } else {
          setEmailminutes(emailminutes - 1)
          setEmailSeconds(59)
        }
      }
      if (emailminutes === 5 && emailseconds === 0 && resendretry === true) {
        setDisResend(false)
      }
    }, 1000)
    return () => {
      clearInterval(myInterval)
    }
  })

  //Email timer counter
  useEffect(() => {
    let myInterval1 = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        if (minutes === 0) {
          Timeout()
          clearInterval(myInterval1)
        } else {
          setMinutes(minutes - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval1)
    }
  })

  // Block access when clientmac is null and blockenv is true
  useEffect(() => {
    var payload = window.location.href
    var url = new URL(payload)
    var clientMAC = url.searchParams.get('client_mac')
    console.log(clientMAC)
    // if (clientMAC === null && process.env.REACT_APP_ENV === 'prod') {
    //   setAccesible(false)
    // } else {
    //   setAccesible(true)
    // }
  }, [])

  // useEffect(() => {
  //   var date = new Date().getTime() / 1000
  //   var timeObj = localStorage.getItem('timeObj')
  //   console.log(timeObj)
  //   if (timeObj != null) {
  //     if (date - timeObj <= 1800) {
  //       console.log('helloo')
  //       setDialogblock(true)
  //     }
  //   }
  // }, [])

  // function Savetime() {
  //   var date = new Date()
  //   var timeObj1 = date.getTime() / 1000
  //   // var timeObj1 = { sec:date.getSeconds(), min:date.getMinutes(), hr:date.getHours() }
  //   console.log(timeObj1)
  //   localStorage.setItem('timeObj', JSON.stringify(timeObj1))
  // }

  //Posts data to db and triggers email to sponsor
  function SubmitGuestData() {
    logEvent({ message: mac }, { level: LogLevel.Info })
    logEvent({ message: 'Heloooooo' }, { level: LogLevel.Info })
    fetch(env.submitGuestDataUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Api-Key': env.key,
      },
      body: JSON.stringify({
        name: name,
        mac_address: mac,
        phone_number: phoneNumber,
        sponsor_email: email,
        location: loc,
        device_type: devicetype,
      }),
    })
      .then((request) => request.json())
      .then((response) => {
        if (response['message'] === 'Invalid number') {
          HandleWrongNumber()
        } else {
          console.log(response)
          requestId(response['id'])
        }
      })
      .catch((err) => console.log('HandleProceedError -> ', err))
  }

  //Sets status
  function HandleWrongNumber() {
    setWrongNumber(true)
    setDisTerms(true)
    setCancelopen(true)
  }

  //Updates OTP status in db
  function UpdateStatus(id, otp) {
    fetch(env.updateGuestStatus, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Api-Key': env.key,
      },
      body: JSON.stringify({
        id: id,
        otp: otp,
      }),
    })
      .then((request) => request.json())
      .then((response) => {
        StatusMsg(response['status'])
      })
      .catch((err) => console.log('HandleProceedError -> ', err))
  }

  //Gets status of sponsor eemail approved or declined
  function SponsorStatus(reqid) {
    fetch(env.sponsorStatusGuestUrl + reqid, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Api-Key': env.key,
      },
    })
      .then((response) => response.json())
      .then((responsedata) => {
        console.log(responsedata)
        setSponsorstatus(responsedata['status'])
        if (responsedata['status'] === 'Approved') {
          handleApprove()
        } else if (responsedata['status'] === 'Declined') {
          handleDecline()
        }
      })
      .catch((err) => console.log('HandleProceedError -> ', err))
  }

  //Re-sends email to sponsor
  function ResendEmail() {
    fetch(env.resendEmailGuestUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Api-Key': env.key,
      },
      body: JSON.stringify({
        id: reqId,
      }),
    })
      .then((request) => request.json())
      .then((response) => {
        console.log(response)
        console.log(response['id'])
      })
      .catch((err) => console.log('HandleProceedError -> ', err))
  }

  //Checks if user is bloked for 30 min
  function BlockUser(phone_number) {
    fetch(env.blockUserUrl, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Api-Key': env.key,
      },
      body: JSON.stringify({
        mac_address: mac,
        phone_number: phone_number,
      }),
    })
      .then((request) => request.json())
      .then((response) => {
        setBlock(response['message'])
      })
      .catch((err) => console.log('HandleProceedError -> ', err))
  }

  //Sets request ID
  function requestId(id) {
    setReqId(id)
  }

  //Sets status
  function StatusMsg(msg) {
    if (msg === 'Approved') {
      window.location.replace(successUrl)
      setOpen(true)
      dialoghandleClose()
    } else if (msg === 'Wrongotp') {
      if (retrynum + 1 < 3) {
        setRetrynum(retrynum + 1)
        setRetry(true)
      } else {
        setDisCode(true)
        setDis(true)
        setDialogblock(true)
        UpdateStatus(reqId, 'Blocked')
        // Savetime()
        setRetry(false)
      }
    }
  }

  //Sets OTP entered
  const handleOtp = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/gi, '')
    setOtp(e.target.value)
  }

  //Set and handles phone number entered
  const handlePhone = (e) => {
    setDis(true)
    setDisEmail(true)
    var phn = '+' + e
    setPhoneNumber(phn)
    setDisCheck(false)
    console.log('hellooo')
    BlockUser(phn)
    setDisEmail(!(phn.length >= 11 && phn.length <= 13))
    if (
      name.length >= 3 &&
      email.length >= 3 &&
      phn.length >= 11 &&
      phn.length <= 13
    ) {
      setDis(false)
    }
  }

  //Set and handles name entered
  const handleName = (e) => {
    setDisPhone(true)
    setDisEmail(true)
    setDis(true)
    e.target.value = e.target.value.replace(/[^A-Za-z0-9_\- ]/g, '')
    if (e.target.value.length >= 3) {
      setName(e.target.value)
      setDisPhone(false)
      setDisEmail(!(phoneNumber.length >= 11 && phoneNumber.length <= 13))
    }
    if (
      e.target.value.length >= 3 &&
      email.length >= 3 &&
      phoneNumber.length >= 11 &&
      phoneNumber.length <= 13
    ) {
      setDis(false)
    }
  }
  const handleEmail = (e) => {
    setDis(true)
    e.target.value = e.target.value.replace(/[^A-z\s0-9.]/gi, '')
    setEmail(e.target.value + '@target.com')
    if (
      e.target.value.length >= 3 &&
      name.length >= 3 &&
      phoneNumber.length >= 11 &&
      phoneNumber.length <= 13
    ) {
      setDis(false)
    }
    console.log(e.target.value + '@target.com')
  }

  //Starts timer and makes POST call to trigger SMS
  const submitClicked = (event) => {
    console.log(mac)
    console.log(email)
    BlockUser(phoneNumber)
    console.log(block)
    if (block === true) {
      setDialogblock(true)
    } else if (block === false) {
      console.log(phoneNumber)
      setMinutes(2)
      setSeconds(0)
      setDialogopenterms(true)
    }
  }

  const handleTerms = () => {
    setCheckstatus('check')
    setEmailminutes(10)
    setEmailSeconds(0)
    SubmitGuestData()
    setDialogemail(true)
    setDialogopenterms(false)
  }

  const handleEmailPopup = () => {
    setCheckstatus(null)
    dialogemailClose()
    setDisok(true)
  }

  const handleDecline = () => {
    console.log('Declineedddddddd')
    setDisok(false)
    setCheckstatus(null)
    setDialogopen(false)
  }

  const handleApprove = () => {
    setDialogemail(false)
    setDialogopen(true)
    setCheckstatus(null)
    setMinutes(2)
    setSeconds(0)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleRetry = () => {
    setRetry(false)
  }

  const handleCancel = () => {
    setCheck(false)
    setDisTerms(true)
    setCancel(false)
  }

  //Enables Next button only if Terms and Condn is checked
  const handleCheck = (e) => {
    setDisTerms(true)
    setCheck(e.target.checked)
    if (e.target.checked === true) {
      setDisTerms(false)
    }
  }

  const dialoghandleClose = (e) => {
    setDialogopen(false)
  }

  const dialogemailClose = (e) => {
    setDialogemail(false)
  }

  const dialogblockClose = (e) => {
    setDialogblock(false)
    window.location.reload()
  }
  //Validates OTP by making a call to backend
  const handleClick = () => {
    if (retrynum >= 2) {
      setRetrynum(retrynum + 1)
      setDisCode(true)
      setCancelopen(true)
    }
    UpdateStatus(reqId, otp)
  }

  //Handle if request is cancelled
  const handleReject = () => {
    UpdateStatus(reqId, '0')
    setCancel(true)
    dialoghandleClose()
  }

  const handleResend = () => {
    setDisResend(true)
    setDisok(true)
    ResendEmail()
    setEmailminutes(10)
    setEmailSeconds(0)
    setResendRetry(false)
  }

  const handleCloseTerms = () => {
    setCancel(true)
    setDialogopenterms(false)
  }

  function Timeout() {
    UpdateStatus(reqId, '')
    dialoghandleClose()
  }

  const classes = useStyles()
  return (
    <React.Fragment>
      <Dialog
        open={dialogblock}
        onClose={dialogblockClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Alert! '}</DialogTitle>
        <DialogContent>
          <Grid container alignItems="left" justify="center" direction="column">
            <Grid item>
              <Typography>
                You have reached the maximum number of retry attempts for the
                phone number {phoneNumber}! Please try again in 30 minutes.
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={dialogblockClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <div
        className="row mx-0"
        style={{
          margin: '1% 5% 3% 5%',
          height: '700px',
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              height: '4.5vh',
              width: '4.5vh',
              paddingTop: '15px',
              marginLeft: '-0.5%',
            }}
          >
            <span className={classes.formHeaderText}>Guest Details</span>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              paddingTop: '10px',
            }}
          >
            <Divider className={classes.formHeaderLine} />
          </Grid>
        </Grid>
        <Grid
          style={{ marginLeft: '0.3%' }}
          container
          alignItems="left"
          justify="center"
          direction="column"
        >
          <br />
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
              }}
            >
              Enter your Name:
            </Typography>
          </Grid>
          <Grid>
            <TextField
              style={{
                width: 250,
                fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
              }}
              className={classes.textField}
              label="Limit 3-25 characters"
              inputProps={{ maxlength: 25 }}
              required
              id="standard-basic"
              onChange={handleName}
            />
          </Grid>
          <br />
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
              }}
            >
              Enter your Phone Number:
            </Typography>
          </Grid>
          <Grid container direction="row">
            {/* <Grid item style={{ marginTop: '4px', marginRight: '3px' }}>
              <Typography variant="body1">+91 </Typography>
            </Grid> */}
            <Grid item>
              <FormControl component="fieldset">
                <form noValidate autoComplete="on">
                  <PhoneInput
                    inputStyle={{
                      width: 250,
                      fontFamily:
                        'Helvetica,Targetica,Helvetica Neue,Helvetica',
                      fontSize: 15,
                    }}
                    disabled={disPhone}
                    inputProps={{ name: 'phoneNumber' }}
                    country="in"
                    value={phoneNumber}
                    // autoFormat = 'false'
                    enableSearch="true"
                    onChange={handlePhone}
                    rules={{ validate: isPossiblePhoneNumber }}
                    // error={phoneNumber && isValidPhoneNumber(phoneNumber) ? 'true' : 'false'}
                  />
                </form>{' '}
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
              }}
            >
              Enter your sponsor’s Target Email ID:
            </Typography>
          </Grid>
          {/* <Grid>
            <TextField
              disabled={disEmail}
              className={classes.textField}
              // inputProps={{ maxlength: 25 }}
              required
              id="standard-basic"
              onChange={handleEmail}
            />
          </Grid>
          <br /> */}
          <Grid item>
            <div>
              {/* <input style={{textAlign:'left', color:'black'}}type="text" size="25" placeholder="sponsormail" defaultValue="@target.com" onChange={handleEmail}></input>
           <br/>
           <br/> */}
              <input
                disabled={disEmail}
                style={{
                  fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
                  fontSize: 15,
                  width: 155,
                  textAlign: 'right',
                  color: 'black',
                  height: '25px',
                  borderStyle: 'solid',
                  borderRadius: '4px',
                  borderLeftRadius: '4px',
                  borderWidth: 0.01,
                  borderLeftWidth: 0.0001,
                  background: 'white',
                }}
                type="text"
                // width= "250"
                // size="20"
                borderStyle="solid"
                borderLeft="-3px"
                placeholder="sponsormail"
                onChange={handleEmail}
              ></input>
              <input
                style={{
                  fontFamily: 'Helvetica,Targetica,Helvetica Neue,Helvetica',
                  fontSize: 15,
                  width: 85,
                  height: '25px',
                  borderStyle: 'solid',
                  borderWidth: 0.01,
                  borderRadius: '4px',
                  borderLeftWidth: 0.0001,
                  borderLeftColor: 'white',
                  background: 'white',
                }}
                type="text"
                value="@target.com"
                // size="12"
                disabled
              ></input>
              <br />
            </div>
            {/* <Email
              disabled={disEmail}
              style={{
                width: '295px',
                height: '30px',
                borderRadius: '4px',
                borderWidth: 0.01,
                borderStyle: 'solid',
                borderColor: '#dcdcdc',
              }}
              className="form-control"
              placeholder="Enter email"
              value={email}
              domains={customDomains}
              onChange={handleEmail}
            /> */}
            {/* {errorMessage && (
              <div className="error" style={{ color: '#cc0000' }}>
                {errorMessage}
              </div>
            )} */}
            <Typography style={{ fontWeight: 'bold', fontSize: '15px' }}>
              *Ensure that you've entered the correct sponsor email ID before
              proceeding further*
            </Typography>
          </Grid>
          <br />
          <Grid item>
            <Typography>
              Target will send a one-time passcode (OTP) to the provided mobile
              number post sponsor approval. Message and data rates may apply.
            </Typography>
          </Grid>
          <br />
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              disabled={dis}
              onClick={submitClicked}
            >
              Next
            </Button>{' '}
          </Grid>
        </Grid>
        <Dialog
          open={dialogopenterms}
          onClose={dialoghandleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" align="center">
            {'Target India Wireless Terms of Use'}
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              alignItems="left"
              justify="center"
              direction="column"
            >
              <Grid item>
                <Typography variant="body1" align="justify">
                  BY CONNECTING TO THIS WIRELESS NETWORK (the "Service"), YOU
                  ACKNOWLEDGE THAT YOU HAVE READ ALL OF THE TERMS AND CONDITIONS
                  OF THIS WIRELESS TERMS OF USE ("TERMS OF USE") BETWEEN YOU AND
                  TARGET CORPORATION INDIA ("Target"), UNDERSTAND THEM, AGREE TO
                  BE LEGALLY BOUND BY THEM AND HAVE THE LEGAL CAPACITY TO DO SO.
                  If you do not agree to these Terms of Use, do not use or
                  access the Service.
                  <br />
                  The Service is offered by Target Corporation India and is not
                  intended to subject Target to the laws or jurisdiction of any
                  state, country or territory other than that of the India. You
                  are responsible for complying with all local laws, rules and
                  regulations. Target reserves the right to charge fees in
                  connection with the Service or to suspend or discontinue the
                  Service, in whole or in part, at any time and in Target’s sole
                  discretion.
                  <br /> <br />
                  <b>Your Responsibilities</b>
                  <br />
                  Use of the Service is at your own risk. There are privacy and
                  security risks associated with connecting to the Internet over
                  wireless communications. The Service is not encrypted or
                  secured in any way, and any material or other communications
                  that you transmit or receive using the Service may be
                  accessible to third parties. While using the Service, you
                  assume full responsibility and risk for: (i) your own privacy
                  and security; (ii) implementing any safeguards you deem to be
                  appropriate to protect and secure your privacy and systems;
                  and (iii) evaluating the suitability, appropriateness or
                  legality of any informational content or other materials you
                  may encounter online
                  <br /> <br />
                  <b>Confidentiality</b>
                  <br />
                  This service is via an open network and hence any one
                  including third parties may access your data or files or
                  otherwise monitor your connection. Target may access, preserve
                  or disclose any such information for purposes of ensuring your
                  compliance with these Terms of Use and applicable law,
                  cooperating with legal authorities, and otherwise protecting
                  the rights, property and interests of Target and its guests
                  and team members. Target cannot assure that your
                  communications or activities will be private or secure during
                  your use of the Service. YOU DO NOT HAVE AN EXPECTATION OF
                  PRIVACY OR CONFIDENTIALITY WHEN USING THE SERVICE
                  <br /> <br />
                  <b>Privacy</b>
                  <br />
                  Target will collect, use, share and protect information about
                  you, except when complying to legal / regulatory enquires, in
                  connection with your use of the Service.
                  <br />
                  We automatically collect information about your use of the
                  Service, including:
                  <br />
                  <li>Your name and mobile number</li>
                  <li>
                    Session data, e.g. date and time device connected to the
                    Service, length of session
                  </li>
                  <li>Device data</li>
                  <br />
                  Ways we use the information we collect include:
                  <br />
                  <li>
                    Internal operations, e.g. enhancing the effectiveness of the
                    Service, analyzing how the Service is used and improving our
                    mobile experience
                  </li>
                  <li>
                    Legal compliance, e.g. assist law enforcement and respond to
                    legal/regulatory inquiries
                  </li>
                  <br />
                  Information may be shared with the following, during
                  transmission & in connection with accessing and the use of
                  this service and they may use and disclose any such
                  information for the purposes of i) administering the service,
                  ii) providing service functionality iii) analysis iv) ensure
                  compliance with this agreement v) adhering to applicable laws:
                  <br />
                  <li>
                    Within Target Corporation, including Target subsidiaries and
                    affiliates.
                  </li>
                  <li>
                    With service providers- companies providing support service
                    (e.g., technical support) that may need information to
                    perform their functions.
                  </li>
                  <li>
                    With third parties (generally this information is anonymous
                    and/or aggregated)
                  </li>
                  <li>
                    For legal requirements- disclosure may occur to comply with
                    law, to enforce or ensure compliance with the Terms of Use,
                    or to protect the rights, property or safety of our company,
                    our team or others.
                  </li>
                  <br />
                  How we protect information:
                  <br />
                  We maintain administrative, technical and physical safeguards
                  to protect your information
                  <br />
                  Information about Children
                  <br />
                  If you are under 18, you may use the Service only with
                  involvement of a parent or guardian, who is bound by these
                  Terms of Use and such parent or guardian will be fully
                  responsible for such child’s use of the Service including
                  financial charges and legal liability that such child may
                  incur.
                  <br /> <br />
                  <b>Prohibited use</b>
                  <br />
                  You agree not to use the Service to transmit or receive any
                  material or other communications that: (i) are unlawful,
                  malicious, fraudulent, harassing, obscene, indecent, tortious
                  or harmful to Target, its guests or any other party; (ii)
                  violate another’s intellectual property, privacy or other
                  rights (including by intercepting, collecting or harvesting
                  any material or other communications transmitted or received
                  by other users of the Service); or (iii) otherwise interfere
                  with the operation, use or enjoyment of the Service or any
                  other service, system or property. In addition, you may not
                  use the Service to transmit or receive any virus, worm, Trojan
                  horse, Easter egg, time bomb, spyware or other computer code,
                  file or program that is harmful or invasive or may or is
                  intended to damage or hijack the operation of, or to monitor
                  the use of, any hardware, software or equipment. Target has
                  the right (but not the obligation), at any time and at its
                  sole discretion, to block inappropriate material, websites or
                  other resources, and/or suspend or terminate an individual’s
                  access to the Service for engaging in these prohibited uses,
                  or for any other reason or no reason at all.
                  <br />
                  <br />
                  <b>Disclaimers</b>
                  <br />
                  THE SERVICE IS PROVIDED SOLELY AS A CONVENIENCE TO YOU, "AS
                  IS" AND "AS AVAILABLE". TARGET AND ITS AFFILIATES,
                  SHAREHOLDERS, DIRECTORS, OFFICERS, TEAM MEMBERS AND AGENTS
                  DISCLAIM ALL WARRANTIES AND REPRESENTATIONS OF ANY KIND,
                  WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING WITHOUT
                  LIMITATION ANY WARRANTIES: (i) OF MERCHANTABILITY, FITNESS FOR
                  A PARTICULAR PURPOSE, OR NON-INFRINGEMENT; OR (ii) THAT ACCESS
                  TO OR USE OF THIS SERVICE OR ANY PART THEREOF WILL BE
                  UNINTERRUPTED, FREE OF VIRUSES OR OTHER HARMFUL CODE, OR
                  SECURE, OR THAT PROBLEMS WILL BE CORRECTED, EVEN IF TARGET IS
                  ON NOTICE OF SUCH PROBLEMS. YOU AGREE THAT NO ADVICE OR
                  INFORMATION GIVEN BY TARGET OR ITS EMPLOYEES SHALL CREATE ANY
                  WARRANTY. YOU AGREE THAT YOUR USE OF THIRD-PARTY WEBSITES AND
                  RESOURCES, ACCESSED THROUGH USE OF THE SERVICE IS AT YOUR OWN
                  RISK AND IS SUBJECT TO THE TERMS AND CONDITIONS OF USE
                  APPLICABLE TO THOSE THIRD-PARTY SITES AND RESOURCES
                  <br />
                  <br />
                  <b>Exclusion of liabilityy</b>
                  <br />
                  TARGET AND ITS AFFILIATES, SHAREHOLDERS, DIRECTORS, OFFICERS,
                  EMPLOYEES AND AGENTS SHALL HAVE NO LIABILITY FOR ANY DIRECT,
                  INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL, PUNITIVE OR
                  EXEMPLARY DAMAGES (INCLUDING, WITHOUT LIMITATION, LOST
                  PROFITS, LOSS OF BUSINESS, BUSINESS INTERRUPTION, LOSS OF DATA
                  OR CONFIDENTIALITY OR SECURITY, OR OTHER SIMILAR DAMAGES)
                  ARISING OUT OF OR RELATED TO THIS AGREEMENT OR THE SERVICE,
                  EVEN IF TARGET IS ADVISED OF THE POSSIBILITY OF ANY SUCH
                  DAMAGES.
                  <br />
                  <br />
                  <b>Miscellaneous</b>
                  <br />
                  Target reserves the right to make changes to these Terms of
                  Use at any time, and such changes will be effective
                  immediately upon being posted. Each time you use the Service,
                  you should review the current Terms of Use. To tell when the
                  most recent updates were made, see the date at the bottom of
                  the Terms of Use. Your continued use of the Service will
                  indicate your acceptance of the current Terms of Use; but any
                  material change to these Terms of Use will not be applied
                  retroactively to any claim or dispute between you and us in
                  connection with these Terms of Use that arose prior to the
                  applicable material change. If any provision of these Terms of
                  Use is found to be unlawful, void or for any reason
                  unenforceable, that provision will be deemed severable from
                  these Terms of Use and will not affect the validity and
                  enforceability of any remaining provision. No waiver by either
                  party of any breach or default hereunder will be deemed to be
                  a waiver of any preceding or subsequent breach or default.
                  These Terms of Use (i) will be governed by and construed in
                  accordance with the laws of India; and (ii) constitute the
                  entire agreement between you and Target regarding the accepted
                  use and terms of the Service.
                  <br />
                  <br />
                  <b>Contact Us:</b>
                  <br />
                  Mail: Target Corporation India Pvt. Ltd.
                  <br />
                  C2, Manyata Embassy Business Park (SEZ)
                  <br />
                  Nagawara Village, Outer Ring Road, Hebbal
                  <br />
                  Bangalore 560045, India
                  <br />
                  Phone: +91 80467 34000
                  <br />
                  <br />
                  last update: 08/02/2021
                  <br />
                  <br />
                </Typography>
              </Grid>
              <Grid>
                <FormControl component="fieldset">
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      checked={check}
                      disabled={disCheck}
                      control={
                        <Checkbox color="primary" onChange={handleCheck} />
                      }
                      label="I agree"
                      labelPlacement="end"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTerms} color="primary">
              Cancel
            </Button>
            <Button disabled={disTerms} onClick={handleTerms}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogemail}
          onClose={dialogemailClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick="true"
          disableEscapeKeyDown="true"
        >
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContent>
            <Grid
              container
              alignItems="center"
              justify="center"
              direction="column"
            >
              <Grid item>
                <Typography>
                  An Email has been sent to your sponsor mail {email} for
                  approval.
                </Typography>
              </Grid>
              {/* <Grid>
                <TextField
                  autoFocus
                  disabled={disCode}
                  id="standard-basic"
                  justify="center"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 6)
                  }}
                  onChange={handleOtp}
                />
              </Grid> */}
            </Grid>
            {/* {retry === true ? <h4>Wrong otp!</h4> : <h4> </h4>} */}
            <div>
              {emailminutes === 0 && emailseconds === 0 ? (
                <div>
                  {resendretry === true ? (
                    <h4>
                      Email Expired! Please recheck if you have entered correct
                      sponsor mail id or not.
                      <br />
                      Click Resend to resend the mail to the
                      <br />
                      same sponsor else click Edit to change the sponsor
                    </h4>
                  ) : (
                    <h4>
                      Email Expired!
                      <br />
                      Please recheck if you have entered correct sponsor mail id
                      or not.
                      <br />
                      Click Edit to change the sponsor mail
                    </h4>
                  )}
                </div>
              ) : (
                <div>
                  {sponsorstatus !== 'Approved' &&
                  sponsorstatus !== 'Declined' ? (
                    <h4>
                      {' '}
                      Valid for {emailminutes}:
                      {emailseconds < 10 ? `0${emailseconds}` : emailseconds}
                    </h4>
                  ) : (
                    <h4>Your sponsor has {sponsorstatus} your request.</h4>
                  )}
                </div>
              )}
            </div>
            {/* <div>
              {retrynum < 3 ? (
                <h4>
                  {''}
                  You have {3 - retrynum} retry attempts!
                </h4>
              ) : (
                <h4>
                  You have reached the maximum number of retry attempts! Please
                  try again in 30 minutes.
                </h4>
              )}
            </div> */}
            {/* <div>
              {(() => {
                if (wrongNumber) {
                  return <h4 style={{ color: 'red' }}>Invalid Phone Number</h4>
                }
              })()}
            </div> */}
          </DialogContent>
          <DialogActions>
            {/* <Button
              disabled={!cancelopen}
              onClick={dialoghandleClose}
              color="primary"
            >
              Ok
            </Button>
            */}
            <Button disabled={disresend} onClick={handleResend} color="primary">
              Resend
            </Button>
            <Button onClick={handleEmailPopup}>Edit</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogopen}
          onClose={dialoghandleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick="true"
          disableEscapeKeyDown="true"
        >
          <DialogTitle id="alert-dialog-title">{'Verify Code '}</DialogTitle>
          <DialogContent>
            <Grid
              container
              alignItems="center"
              justify="center"
              direction="column"
            >
              <Grid item>
                <div>
                  {sponsorstatus === 'Approved' ? (
                    <Typography>
                      Your sponsor has approved your request.
                    </Typography>
                  ) : (
                    <h4> </h4>
                  )}
                </div>
              </Grid>
              <Grid item>
                <Typography>
                  Enter the code sent to your mobile number {phoneNumber}.
                </Typography>
              </Grid>
              <Grid>
                <TextField
                  autoFocus
                  disabled={disCode}
                  id="standard-basic"
                  justify="center"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 6)
                  }}
                  onChange={handleOtp}
                />
              </Grid>
            </Grid>
            {retry === true ? <h4>Wrong otp!</h4> : <h4> </h4>}
            <div>
              {(minutes === 0 && seconds === 0) || retrynum >= 3 ? (
                <h4>Code Expired!</h4>
              ) : (
                <h4>
                  {' '}
                  Code valid for {minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </h4>
              )}
            </div>
            <div>
              {retrynum < 3 ? (
                <h4>
                  {''}
                  You have {3 - retrynum} retry attempts!
                </h4>
              ) : (
                <h4>
                  You have reached the maximum number of retry attempts! Please
                  try again in 30 minutes.
                </h4>
              )}
            </div>
            <div>
              {(() => {
                if (wrongNumber) {
                  return <h4 style={{ color: 'red' }}>Invalid Phone Number</h4>
                }
              })()}
            </div>
          </DialogContent>
          <DialogActions>
            {/* <Button
              disabled={!cancelopen}
              onClick={dialoghandleClose}
              color="primary"
            >
              Ok
            </Button> */}
            <Button
              disabled={cancelopen}
              onClick={handleReject}
              color="primary"
            >
              Cancel
            </Button>
            <Button disabled={cancelopen} onClick={handleClick}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            Successfully Authorized
          </Alert>
        </Snackbar>
        <Snackbar open={retry} autoHideDuration={5000} onClose={handleRetry}>
          <Alert onClose={handleRetry} severity="error">
            Wrong OTP
          </Alert>
        </Snackbar>
        <Snackbar open={cancel} autoHideDuration={5000} onClose={handleCancel}>
          <Alert onClose={handleCancel} severity="error">
            Request Cancelled
          </Alert>
        </Snackbar>{' '}
      </div>
      <div>
        <Dialog
          // open={!accesible}
          //TransitionComponent={Transition}
          keepMounted
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {'RESTRICTED'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Not accessible outside Target Network
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    </React.Fragment>
  )
}

export default GuestDetails
